import { c as _c } from "react/compiler-runtime";
import React from "react";
interface MapIconProps {
  size?: number;
  className?: string;
}
const MapIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const t2 = `dynamic-size ${className}`;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M5.5 10.2027C5.5 6.4756 8.43512 3.5 12 3.5C15.5649 3.5 18.5 6.4756 18.5 10.2027C18.5 11.0074 18.1324 12.0627 17.4551 13.2749C16.7916 14.4625 15.8939 15.6912 14.9759 16.8135C14.061 17.9322 13.1434 18.9242 12.4532 19.6377C12.2877 19.8088 12.1355 19.9635 12 20.0998C11.8645 19.9635 11.7123 19.8088 11.5468 19.6377C10.8566 18.9242 9.93897 17.9322 9.02408 16.8135C8.10615 15.6912 7.2084 14.4625 6.54487 13.2749C5.86764 12.0627 5.5 11.0074 5.5 10.2027ZM11.3151 22.2287C11.3153 22.2288 11.3154 22.229 12 21.5C12.6846 22.229 12.6847 22.2288 12.6849 22.2287L12 22.8718L11.3151 22.2287ZM11.3151 22.2287L12 21.5L12.6849 22.2287L12.6868 22.2269L12.6917 22.2222L12.7096 22.2053C12.725 22.1907 12.7473 22.1695 12.776 22.142C12.8335 22.0869 12.9167 22.0066 13.0221 21.9034C13.2327 21.6971 13.532 21.399 13.8906 21.0283C14.6066 20.2883 15.564 19.2537 16.5241 18.0797C17.4811 16.9095 18.4584 15.5797 19.2011 14.2503C19.9301 12.9455 20.5 11.5251 20.5 10.2027C20.5 5.42164 16.7194 1.5 12 1.5C7.28061 1.5 3.5 5.42164 3.5 10.2027C3.5 11.5251 4.06986 12.9455 4.79888 14.2503C5.5416 15.5797 6.51885 16.9095 7.47592 18.0797C8.43603 19.2537 9.39342 20.2883 10.1094 21.0283C10.468 21.399 10.7673 21.6971 10.9779 21.9034C11.0833 22.0066 11.1665 22.0869 11.224 22.142L11.2536 22.1703L11.2904 22.2053L11.3083 22.2222L11.3132 22.2269L11.3151 22.2287ZM10.5 9.5C10.5 8.67157 11.1716 8 12 8C12.8284 8 13.5 8.67157 13.5 9.5C13.5 10.3284 12.8284 11 12 11C11.1716 11 10.5 10.3284 10.5 9.5ZM12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 11.433 10.067 13 12 13C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6Z" fill="#2A2A31" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t2 || $[4] !== t4) {
    t6 = <svg className={t2} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style={t4}>{t5}</svg>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default MapIcon;